

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import { getDate } from '../utils/getDate'
import { padOutZeros } from '../utils/padOutZeros'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import SummaryCheckWindow from './SummaryCheckWindow'
import { get } from 'http'

type Props = {
    thisChecklistPeriod: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue
}

function FormatCheckPeriodTimeRange({
    thisChecklistPeriod,
    thisChecklist
}: Props) {

    const {
        t
    } = useContext(GlobalContext)


    const [showCheckPeriods, setShowCheckPeriods] = useState(false)


    const checkPeriodId = thisChecklistPeriod && thisChecklistPeriod['Id']
    const check_period_end = thisChecklistPeriod && thisChecklistPeriod['EndHoursMins']
    const check_period_start = thisChecklistPeriod && thisChecklistPeriod['StartHoursMinsDay']
    const startTimeStamp = thisChecklistPeriod && `${thisChecklistPeriod['StartTimeStamp']}`
    const endTimeStamp = thisChecklistPeriod && `${thisChecklistPeriod['EndTimeStamp']}`
    const startDay = thisChecklistPeriod && getDate(startTimeStamp, 'dayAndDate')
    const endDay = thisChecklistPeriod && getDate(endTimeStamp, 'dayAndDate')

    const startTimeString = check_period_start ? `${padOutZeros(check_period_start['hours'])}:${padOutZeros(check_period_start['minutes'])}` : ''
    const endTimeString = check_period_end ? `${padOutZeros(check_period_end['hours'])}:${padOutZeros(check_period_end['minutes'])}` : ''

    const numberOfCheckWindows = thisChecklist && thisChecklist['Schedule'] && thisChecklist['Schedule']['CheckWindows'] ? Object.keys(thisChecklist['Schedule']['CheckWindows']).length : 0

    if (!thisChecklistPeriod) {
        return null
    }

    return <div className={`flex flex-row gap-2 text-xs`}>


        <p className={``}>
            {startDay} {startTimeString}
            {endTimeString !== startTimeString && ` - ${endTimeString}`} </p>


        {numberOfCheckWindows > 0 &&
            <p
                className={`underline hover:opacity-80 cursor-pointer`}
                onClick={() => setShowCheckPeriods(true)}>

                {numberOfCheckWindows === 1 && t('Dashboard.FormatCheckPeriodTimeRange.showOneCheckPeriod')}

                {numberOfCheckWindows > 1 && t('Dashboard.FormatCheckPeriodTimeRange.showMultipleCheckPeriods', { numberOfCheckWindows })}

            </p>
        }



        {showCheckPeriods && <Modal showCloseButton={true} setShowModal={setShowCheckPeriods}>
            <h4 className={`text-lg font-righteous text-brandblue`}>
                {t('Dashboard.FormatCheckPeriodTimeRange.checkPeriods')}
            </h4>
            <div className={`mt-2 mb-4 flex flex-col gap-2`}>{
                thisChecklist &&
                    thisChecklist['Schedule'] &&
                    thisChecklist['Schedule']['CheckWindows'] &&
                    Object.keys(thisChecklist['Schedule']['CheckWindows']).length > 0 ?
                    Object.keys(thisChecklist['Schedule']['CheckWindows']).map((checkWindowId, index) => {
                        return <SummaryCheckWindow
                            key={index}
                            checkWindowId={checkWindowId}
                            checkWindow={thisChecklist['Schedule']['CheckWindows'][checkWindowId]}
                        />
                    }) :

                    thisChecklist['Schedule'] &&
                    thisChecklist['Schedule']['Frequency'] &&
                    thisChecklist['Schedule']['Frequency'] !== 'ADHOC' &&
                    <RedAlert icon={true} alignment={'left'}>
                        {t('Dashboard.FormatCheckPeriodTimeRange.noCheckingTimes')}
                    </RedAlert>
            }
            </div>
            <Button
                onClick={() => setShowCheckPeriods(false)}
                text={t('Buttons.close')}
                variant={`primary`}
                fullwidth={true}
            //size={'big'}
            />
        </Modal>}
    </div>
}

export default FormatCheckPeriodTimeRange